import React from 'react';

/** Animated expand/collapse wrapper for filter drawer accordions (CSS grid 0fr → 1fr). */
export default function AccordionPanel({ isOpen, children, className = '' }) {
  return (
    <div
      className={`accordion-panel ${isOpen ? 'is-open' : ''} ${className}`.trim()}
      aria-hidden={!isOpen}
    >
      <div className="accordion-panel__inner">
        <div className="accordion-content">{children}</div>
      </div>
    </div>
  );
}
